import { Injectable } from '@angular/core';
import {Dua} from "app/archivage/common/services/dua/dua.model";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";
import {DaoGenericWithStorage} from "app/archivage/common/helper/helperDaoGeneric";


@Injectable({
  providedIn: 'root'
})
export class DuaService extends DaoGenericWithStorage<Dua> {
  private url = `${environment.baseUrl}/api_archive/dua/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }
}
